import styled from 'styled-components';
import { useIntl } from '@pass-frontend/common/i18n';
import { RdsIcon } from '@pass-frontend/rally-energon-react';

interface SuccessInfoProps {
  isGovernmentDependent?: boolean;
  message: string;
}

const SuccessMessage = styled.div`
  background-color: #dbf3e5;
  color: #277447;

  .success-info-image {
    align-self: start;
  }
`;

export const SuccessInfo = ({
  isGovernmentDependent = false,
  message = '',
}: SuccessInfoProps) => {
  const { t } = useIntl();

  return (
    <SuccessMessage className="is-flex has-rds-pv-16 has-rds-ph-24 has-rds-mb-16">
      <div className="success-info-image is-flex has-rds-mr-8">
        <RdsIcon name="indicator-yes-filled" />
      </div>
      <div className="is-display-flex is-flex-direction-column">
        <div className="is-rds-body-3">
          <b>{message}</b>
        </div>
        {isGovernmentDependent && (
          <div className="is-rds-body-3 has-rds-text-grey-dark">
            <b>{t('facilityWeb.memberDetail.govDepAccompanied')}</b>
          </div>
        )}
      </div>
    </SuccessMessage>
  );
};
